import React from "react";
import { MdCancel } from "react-icons/md";

const CancelButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-md bg-red-600 text-white px-4 sm:px-6 text-sm sm:text-base font-medium transition hover:bg-red-500/80 hover:scale-105"
    >
      <MdCancel className="me-1 text-lg sm:text-xl" />
      <span>Cancel</span>
      <div className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-100%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(100%)]">
        <div className="relative h-full w-8 bg-white/20"></div>
      </div>
    </button>
  );
};

export default CancelButton;
